import React from "react";
import { HStack, VStack, Text, Skeleton } from "@chakra-ui/react";
import { useQueryParams } from "duck";
import { useGetReportQuery } from "requests";

const Statistics: React.FC = () => {
  const [{ filter }] = useQueryParams();
  const { data, loading } = useGetReportQuery({
    variables: {
      dateFilter: filter?.date
    }
  });

  return (
    <HStack spacing={14}>
      <VStack spacing={1} align="start">
        <Text fontWeight="semibold" color="gray.500" fontSize="sm">
          Active Users:
        </Text>
        {loading ? (
          <Skeleton h={6} w="full" />
        ) : (
          <Text fontWeight="bold" color="gray.700">
            {data?.reportOrganizationCounter?.usersCount}
          </Text>
        )}
      </VStack>
      <VStack spacing={1} align="start">
        <Text fontWeight="semibold" color="gray.500" fontSize="sm">
          Active Organizations:
        </Text>
        {loading ? (
          <Skeleton h={6} w="full" />
        ) : (
          <Text fontWeight="bold" color="gray.700">
            {data?.reportOrganizationCounter?.activeOrganizationsCount}
          </Text>
        )}
      </VStack>
      <VStack spacing={1} align="start">
        <Text fontWeight="semibold" color="gray.500" fontSize="sm">
          Archived Organizations:
        </Text>
        {loading ? (
          <Skeleton h={6} w="full" />
        ) : (
          <Text fontWeight="bold" color="gray.700">
            {data?.reportOrganizationCounter?.archivedOrganizationsCount}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export default Statistics;
